module.exports = __webpack_public_path__ + "img/en_logo_active.28fe68a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/header/images/en_logo_active.png
// module id = /b3g
// module chunks = 1 15